/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import {HashRouter, Route, Routes} from "react-router-dom";
import AppHeader from "./components/main/AppHeader";
import NavigationBar from "./components/main/NavigationBar";
import HomePage from "./components/main/HomePage";
import CreateTag from "./components/tags/CreateTag";
import TagList from "./components/tags/TagList";
import CreatePart from "./components/parts/CreatePart";
import PartList from "./components/parts/PartList";
import CreatePrinter from "./components/printers/CreatePrinter";
import PrinterList from "./components/printers/PrinterList";
import CreateEffectivity from "./components/effectivities/CreateEffectivity";
import EffectivityList from "./components/effectivities/EffectivityList";
import EditPart from "./components/parts/EditPart";
import EditPrinter from "./components/printers/EditPrinter";
import EditEffectivity from "./components/effectivities/EditEffectivity";
import NoMatch from "./components/main/NoMatch";
import NotAuthorized from "./components/main/NotAuthorized";
import {ACCESS_TOKEN_KEY} from "../utilities/Constants";
import {decodeToken} from "../utilities/auth/Introspect";

class App extends React.Component {

    render() {
        const role = decodeToken(JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY)));
        const admin = role.admin;
        const user = role.user;
        if (admin) {
            return (
                <HashRouter>
                    <div className="app-header">
                        <AppHeader/>
                    </div>
                    <div className="spacing-bar"/>
                    <div className="navigation-bar">
                        <NavigationBar/>
                    </div>
                    <div className="render-component">
                        <Routes>
                            <Route exact path="/" element={<HomePage/>}/>
                            <Route exact path="/create-tag" element={<CreateTag/>}/>
                            <Route exact path="/tag-list" element={<TagList/>}/>
                            <Route exact path="/create-part" element={<CreatePart/>}/>
                            <Route exact path="/edit-part" element={<EditPart/>}/>
                            <Route exact path="/part-list" element={<PartList/>}/>
                            <Route exact path="/create-printer" element={<CreatePrinter/>}/>
                            <Route exact path="/edit-printer" element={<EditPrinter/>}/>
                            <Route exact path="/printer-list" element={<PrinterList/>}/>
                            <Route exact path="/create-effectivity" element={<CreateEffectivity/>}/>
                            <Route exact path="/edit-effectivity" element={<EditEffectivity/>}/>
                            <Route exact path="/effectivity-list" element={<EffectivityList/>}/>
                            <Route exact path="/not-authorized" element={<NotAuthorized/>}/>
                            <Route exact path="*" element={<NoMatch/>}/>
                        </Routes>
                    </div>
                </HashRouter>
            );
        } else if (user) {
            return (
                <HashRouter>
                    <div className="app-header">
                        <AppHeader/>
                    </div>
                    <div className="spacing-bar"/>
                    <div className="navigation-bar">
                        <NavigationBar/>
                    </div>
                    <div className="render-component">
                        <Routes>
                            <Route exact path="/" element={<HomePage/>}/>
                            <Route exact path="/create-tag" element={<CreateTag/>}/>
                            <Route exact path="/tag-list" element={<TagList/>}/>
                            <Route exact path="/create-part" element={<NotAuthorized/>}/>
                            <Route exact path="/edit-part" element={<NotAuthorized/>}/>
                            <Route exact path="/part-list" element={<PartList/>}/>
                            <Route exact path="/create-printer" element={<NotAuthorized/>}/>
                            <Route exact path="/edit-printer" element={<NotAuthorized/>}/>
                            <Route exact path="/printer-list" element={<PrinterList/>}/>
                            <Route exact path="/create-effectivity" element={<NotAuthorized/>}/>
                            <Route exact path="/edit-effectivity" element={<NotAuthorized/>}/>
                            <Route exact path="/effectivity-list" element={<EffectivityList/>}/>
                            <Route exact path="/not-authorized" element={<NotAuthorized/>}/>
                            <Route exact path="*" element={<NoMatch/>}/>
                        </Routes>
                    </div>
                </HashRouter>
            );
        } else {
            return (
                <HashRouter>
                    <div className="app-header">
                        <AppHeader/>
                    </div>
                    <div className="spacing-bar"/>
                    <div className="navigation-bar">
                        <NavigationBar/>
                    </div>
                    <div className="render-component">
                        <Routes>
                            <Route exact path="*" element={<NotAuthorized/>}/>
                        </Routes>
                    </div>
                </HashRouter>
            );
        }
    }
}

export default App;
